import { useState } from 'react';
import CountdownTimer from './CountdownTimer';
import chargerimg from './styles/chargerimg.png';
 

function ChargerSVG({ dark }) {
  return (
    <img
      src={dark ? chargerimg : chargerimg}
      alt="Charger"
      className="mx-auto"
      width="250"
      height="400"
    />
  );
}
export default function HeroSection({ dark }) { 
  return (
    <>
    <CountdownTimer />
      <section
        className="w-full max-w-6xl mx-auto px-6 sm:px-12  lg:py-20 py-10   flex flex-col items-center text-center min-h-[88vh]    gap-12"
      >
        {/* TOP - Content */}
        <div className="w-full max-w-full">
          {/* Heading */}
          <div className="mb-7">
            <span className="block relative w-fit mx-auto mb-2 px-2">
              <span
                className="relative z-10 text-white px-2 font-['Bebas_Neue'] tracking-wide"
                style={{ fontSize: 'clamp(28px, 3.5vw, 44px)' }}
              >
                Driving the Next Shift in EV Charging
              </span>
              <span className="absolute inset-0 bg-[#33D47E] -skew-x-12 " />
            </span>

            <h1
              className="font-['Bebas_Neue'] leading-[1] tracking-wide"
              style={{ fontSize: 'clamp(56px, 7vw, 90px)' }}
            >
               <span className=" text-[#00C76A]">500 mm  </span>
              <span className=" text-gray-900 dark:text-gray-100">
              Less. More Power. {' '}
              </span>
             
            </h1>
            

            {/* Coming Soon badge */}
            <div
              className="mt-4 inline-flex items-center gap-2 border border-white
                px-4 py-1.5 rounded-full  
                 bg-[#00C76A] transition-colors duration-200 cursor-pointer group"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-dot-pulse" />
              <span
                className="text-[11px] tracking-[3px] uppercase   font-medium
                   text-white transition-colors duration-200"
              >
                Coming Soon — May 22, 2026
              </span>
            </div>
          </div> 
        </div>

        {/* BOTTOM - SVG centered */}
        <div className="flex justify-center items-center">
          <div className="relative w-[280px] h-[380px]">
            {/* Corner brackets */}
            {[
              'top-3 left-3 border-t-2 border-l-2',
              'top-3 right-3 border-t-2 border-r-2',
              'bottom-3 left-3 border-b-2 border-l-2',
              'bottom-3 right-3 border-b-2 border-r-2',
            ].map((cls, i) => (
              <div
                key={i}
                className={`absolute w-4 h-4 border-[#00C76A] opacity-40 ${cls}`}
              />
            ))}

            {/* Glow */}
            <div
              className="absolute top-1/2 left-1/2 w-[360px] h-[360px] rounded-full
                      bg-[radial-gradient(circle,rgba(0,199,106,0.12)_0%,transparent_65%)]
                      animate-glow-breathe pointer-events-none"
            />

            {/* Scan line */}
            <div
              className="absolute left-[10%] right-[10%] h-[2px] z-10
                      bg-[linear-gradient(90deg,transparent,rgba(0,199,106,0.9),transparent)]
                      animate-scan"
            />

            {/* Charger */}
            <div className="relative z-[2] ">
              <ChargerSVG dark={dark} />
            </div>

         
          </div>
        </div>
      </section>
      {/* Countdown embedded below hero, visible on first load */}
      
    </>
  );
}
